<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <v-app>
        <v-content>
          <v-container>
          
          <v-card>
            <v-flex xs8 pa-4>
            <v-alert
              value="message" v-if="message"
              type="success"
              outline
            > <span> {{ message }} </span>
            </v-alert>
            
             <v-alert
              value="error" v-if="error"
              type="warning"
              outline
            > <span> {{ error }} </span>
            </v-alert>

            <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field 
              name="name" 
              label="Name" 
              v-model.trim="role.name"
              :rules="nameRules" 
              required>
            </v-text-field>

            <v-text-field 
              name="description" 
              label="Description" 
              v-model.trim="role.description"
              :rules="descriptionRules" 
              required>
            </v-text-field>
            <h4> User Permissions </h4>
            <v-flex>
               <v-chip color="secondary" :key="selected" v-for="selected in role.selectedPermissions">{{ selected }}</v-chip>
            </v-flex>
            <v-data-iterator
              :items="permissions"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              content-tag="v-layout"
              row
              wrap
            >
              <v-flex
                slot="item"
                slot-scope="props"
              >
                <v-checkbox :label="props.item.action" :key="props.item.id" v-model="role.selectedPermissions" :value="props.item.action">
                </v-checkbox>
              </v-flex>
            </v-data-iterator>

            <v-card-actions>
              <v-btn @click="createRole" color="primary">Create Role</v-btn>
            </v-card-actions>
            </v-form>
            </v-flex>
             
          </v-card>
        
        </v-container>
        </v-content>
      </v-app>
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>
<script>
import axios from 'axios'
import config from '../../config'
import store from '../../store'

export default {
  name: 'createrole',
  data: function() {
    return {
      role: {
        'name': '',
        'description': '',
        'selectedPermissions': []
      },
      valid: true,
      nameRules: [
        v => !!v || 'Name is required'
      ],
      descriptionRules: [
        v => !!v || 'Description is required'
      ],
      message: '',
      error: '',
      rowsPerPageItems: [4, 8, 12],
      pagination: {
        rowsPerPage: 4
      },
      permissions: []
    }
  },
  mounted () {
    this.getDataFromApi()
    .then(data => {
      // this.permissions = data.items
      // this.totalPermissions = data.total
    })
  },
  methods: {
    createRole() {
      this.message = ''
      this.error = ''
      // this.permissions = []
      if (this.$refs.form.validate()) {
        var url = config.serverURI + '/admin/role/create'
        var token = store.state.token
        console.log(token)
        axios.post(url, this.role, {
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            if (response.data.error !== false) {
              this.error = response.data.message
              console.log('Error is ' + this.error)
              return
            }

            this.valid = true
            this.resetRoleObject()
            this.message = response.data.message
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      }
    },
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        let items = this.getPermissions()
        const total = items.length

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    resetRoleObject() {
      this.role.name = ' '
      this.role.description = ' '
      this.role.selectedPermissions = []
    },
    getPermissions () {
      var url = config.serverURI + '/permission/getall'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.permissions = response.data
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      console.log(this.permissions)
      return this.permissions
    }

  }
}

</script>
<style>
.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// createrole.vue?52877d89